// removed by extract-text-webpack-plugin
module.exports = {"main":"_2NLtdZ0KyTpHL5rDWYFEBA","children":"hmyfPIorSW1iOVoZ8oj-P"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/basic/Image.scss
// module id = 687
// module chunks = 12